// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","App-header":"App_App-header__xLkWl","main":"App_main__3ZkGI","mainlink":"App_mainlink__2qmSz"};